export const AUTH_PRODUCTS = Object.freeze({
  SHUFFLEMAPS: 'shufflemaps',
  SHUFFLEDB: 'shuffledb',
  CAPDAT: 'capdat',
  TRACKDAT: 'trackdat',
  POSTDAT: 'postdat',
  EDITDAT: 'editdat',
});

export const AUTH_PRODUCT_ORIGIN_COOKIE = 'shuffledb_auth_product_origin';
export const AUTH_PRODUCT_CALLBACK_COOKIE = 'shuffledb_auth_product_callback';

const VALID_AUTH_PRODUCTS = new Set(Object.values(AUTH_PRODUCTS));

export function normalizeAuthProduct(value, fallback = AUTH_PRODUCTS.SHUFFLEDB) {
  const normalized = String(value || '').trim().toLowerCase();
  return VALID_AUTH_PRODUCTS.has(normalized) ? normalized : fallback;
}

export function isSafeAuthCallbackPath(value) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return false;
  try {
    return new URL(value, 'https://shuffledb.local').origin === 'https://shuffledb.local';
  } catch {
    return false;
  }
}

export function normalizeAuthCallbackPath(value, fallback = '/') {
  return isSafeAuthCallbackPath(value) ? value : fallback;
}

export function readCookieValue(cookieHeader, cookieName) {
  if (!cookieHeader || !cookieName) return '';
  const prefix = `${cookieName}=`;
  const entry = String(cookieHeader).split(';').map((part) => part.trim())
    .find((part) => part.startsWith(prefix));
  if (!entry) return '';
  try {
    return decodeURIComponent(entry.slice(prefix.length));
  } catch {
    return '';
  }
}
